import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import styles from './css/SelectList.styl';

/**
 * SelectList Component
 * @param {Object} props Component Properties
 * @returns {JSX} SelectList JSX
 */
export default class SelectList extends React.Component {
  static propTypes = {
    ariaDescribedBy: React.PropTypes.string,
    ariaLabel: React.PropTypes.string,
    ariaRequired: React.PropTypes.string,
    className: React.PropTypes.string,
    defaultValue: React.PropTypes.oneOfType([
      React.PropTypes.number.isRequired,
      React.PropTypes.string.isRequired,
    ]),
    disabled: React.PropTypes.bool,
    handleBlur: React.PropTypes.func,
    handleChange: React.PropTypes.func.isRequired,
    handleFocus: React.PropTypes.func,
    id: React.PropTypes.string,
    isInvalid: React.PropTypes.bool,
    name: React.PropTypes.string,
    options: React.PropTypes.array.isRequired,
    value: React.PropTypes.oneOfType([
      React.PropTypes.number.isRequired,
      React.PropTypes.string.isRequired,
    ]),
  };

  /**
   * SelectList Component Constructor
   * @param  {Object} props Passed in Properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.id = props.id ? `${props.id}_selectlist` : null;

    this._textInput = null;

    this.setRefSelectList = this.setRefSelectList.bind(this);
  }

  /**
   * Constructs the className string
   * @param  {Boolean} isDisabled If the component is disabled
   * @param  {Boolean} isInvalid  If the component is inValid
   * @param  {Boolean} hasValue   If something other than the default value is selected
   * @return {String} The classname string
   */
  getClasses(isDisabled, isInvalid, hasValue) {
    const conditionalClasses = {};

    conditionalClasses[styles.disabled] = isDisabled;
    conditionalClasses[styles.error] = isInvalid;
    conditionalClasses[styles.hasValue] = hasValue;

    return classNames(conditionalClasses);
  }

  /**
   * Filter function to determine if an option is valid
   * @param  {Object} option The option to check
   * @return {Boolean} Whether or not it's valid
   */
  filterBadOption(option) {
    return (
      option.name && (_.isString(option.value) || _.isNumber(option.value))
    );
  }

  /**
   * Setter for select list ref
   * @param {Element} selectList The selectlist element
   * @returns {Undefined} Returns nothing
   */
  setRefSelectList(selectList) {
    if (selectList) {
      this._selectList = selectList;
    }
  }

  /**
   * Returns the chevron to display based on selectlist state
   * @return {String} SVG source
   */
  getChevron() {
    return `<svg version="1.1" id="Layer_1" xmlns="https://www.w3.org/2000/svg"
        xmlns:xlink="https://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.3 8.3"
        style="enable-background:new 0 0 12.3 8.3;" xml:space="preserve">
        <style type="text/css">
          .st3{fill:currentColor;}
        </style>
        <g>
          <polygon class="st3" points="6.2,7.8 0.5,2.7 2.5,0.5 6.2,3.8 9.8,0.5 11.8,2.7 	"/>
        </g>
      </svg>`;
  }

  /**
   * React Component render
   * @return {JSX} TextArea rendered
   */
  render() {
    const filteredOptions = this.props.options.filter(this.filterBadOption);
    const hasValue = this.props.value !== this.props.defaultValue;
    const className = this.getClasses(
      this.props.disabled,
      this.props.isInvalid,
      hasValue
    );

    return (
      <div className={classNames(styles.SelectList, this.props.className)}>
        <span className={hasValue ? styles.hasValue : null}>
          <svg fill="currentColor" viewBox="0 0 12.3 8.3" x="0px" y="0px">
            <polygon
              className="st3"
              points="6.2,7.8 0.5,2.7 2.5,0.5 6.2,3.8 9.8,0.5 11.8,2.7"
            />
          </svg>
        </span>
        <select
          aria-describedby={this.props.ariaDescribedBy}
          aria-label={this.props.ariaLabel}
          aria-required={this.props.ariaRequired}
          className={className}
          disabled={this.props.disabled}
          id={this.id}
          name={this.props.name}
          onBlur={this.props.handleBlur}
          onChange={this.props.handleChange}
          onFocus={this.props.handleFocus}
          ref={this.setRefSelectList}
          value={this.props.value}
        >
          {filteredOptions.map((option, key) => (
            <option key={key} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FormControls/SelectList.js